<template>
    <div class="program-container">
        <program-item 
            v-for="(item, idx) in programList"
            :key="idx"
            :item="item" 
            v-on:openModal="openModal"
        >
        </program-item>
        <program-modal
            v-if="displayModal"
            :item="itemSelected"
            v-on:closeModal="closeModal"
        ></program-modal>
    </div>
</template>

<script>
import ProgramItem from "./ProgramItem";
import ProgramModal from './ProgramModal.vue'

export default {
    name : "Program",
    components : {
        ProgramItem,
        ProgramModal
    },
    data() {
        return {
            programList : [
                {
                    id : 1,
                    name : "SÉANCE INDIVIDUELLE<br /> SUR-MESURE",
                    place : "RIVHA PILATES",
                    descLight : "REFORMER<sup>TM</sup> ET/OU MATWORK <span>+</span> ACCESSOIRES <br />CADILLAC<sup>TM</sup> / STABILITY BARRE<sup>TM</sup> <br /> STABILITY CHAIR<sup>TM</sup> / ARC BARRELS<sup>TM</sup> <br /> CARDIO TRAMP<sup>TM</sup>",
                    descFull : "Situé à Saint-Rémy-de-Provence dans la région des Alpilles, Rivha Studio propose des ateliers uniques pour une prise en charge totalement personnalisée et sécurisée.<br/><br /> Dans l’intimité du studio confidentiel, nous travaillons postures, exercices de renforcement et relaxation nécessaires pour préserver un corps tonique et un mental équilibré. Renforcement des articulations, rééducation après une blessure, travail anti-stress, soin post et prénatal… <br/><br /> Pour accéder à ces séances d’accompagnement exclusives et sur-mesure avec accessoires et/ou machines <a href='https://www.merrithew.com/' target='blank'>Merrithew®</a> (REFORMER<sup>TM</sup> / CADILLAC<sup>TM</sup> / STABILITY BARRE<sup>TM</sup> / STABILITY CHAIR<sup>TM</sup> / ARC BARRELS<sup>TM</sup> / CARDIO TRAMP<sup>TM</sup>), veuillez me contacter via le formulaire de contact.",
                    time : "60",
                    price : "90"
                },
                {
                    id : 3,
                    name : "SÉANCE INDIVIDUELLE<br />PRÉNATAL / POSTNATAL",
                    place : "RIVHA PILATES",
                    descLight : "REFORMER<sup>TM</sup> ET/OU MATWORK <span>+</span> ACCESSOIRES <br />CADILLAC<sup>TM</sup> / STABILITY BARRE<sup>TM</sup> <br /> STABILITY CHAIR<sup>TM</sup> / ARC BARRELS<sup>TM</sup> <br /> CARDIO TRAMP<sup>TM</sup>",
                    descFull : "La grossesse est un changement physique et moral que chaque femme vit différemment. Les séances privées de Rivha Pilates visent à soulager le corps et renforcer le système de soutien abdominal pour préparer les futures mamans à l’accouchement.<br/><br />  En soin postnatal, le Pilates est d'une grande aide pour reprendre confiance en soi et en ses capacités, regagner cette énergie si nécessaire pour l’écriture de ce nouveau chapitre de la vie.<br />Après un accouchement par voie basse ou par césarienne, les séances de Rivha Pilates contribuent à accélérer le processus de guérison post-partum. <br/><br /> Grâce à des exercices ciblés, Rivha Studio aide les femmes enceintes ou qui ont récemment accouché à maintenir l’équilibre psychique et physique dont elles ont tant besoin.<br /><br />Pour accéder à ces séances d’accompagnement exclusives et sur-mesure avec accessoires et/ou machines <a href='https://www.merrithew.com/' target='blank'>Merrithew®</a><br /> (REFORMER<sup>TM</sup> / CADILLAC<sup>TM</sup> / STABILITY BARRE<sup>TM</sup> / STABILITY CHAIR<sup>TM</sup> / ARC BARRELS<sup>TM</sup> / CARDIO TRAMP<sup>TM</sup>), veuillez me contacter via le formulaire de contact.<br /><br/><i>Conditions d’accès aux cours prénataux et postnataux : <br />Avant toute rééducation et reprise sportive, vous devez consulter l’avis d’un professionnel de santé. Les femmes enceintes ou en période post-partum souhaitant participer aux séances prénatales ou postnatales doivent présenter un certificat médical attestant de leur aptitude à pratiquer la méthode Pilates. En l’absence dudit document, la professeure se réserve le droit de ne pas accepter la participante en séance.</i>",
                    time : "50",
                    price : "80"
                },
                              {
                    id : 4,
                    name : "SÉANCE INDIVIDUELLE<br />BARRE AU SOL",
                    place : "RIVHA PILATES",
                    descLight : "REFORMER<sup>TM</sup> ET/OU MATWORK <span>+</span> ACCESSOIRES <br />CADILLAC<sup>TM</sup> / STABILITY BARRE<sup>TM</sup> <br /> STABILITY CHAIR<sup>TM</sup> / ARC BARRELS<sup>TM</sup> <br /> CARDIO TRAMP<sup>TM</sup>",
                    descFull : "Besoin d’un recentrage, d’un moment de détente profonde ou d’un véritable réalignement ? Rivha Studio vous accueille pour des séances individuelles de Barre au sol, élaborées exclusivement autour de vos attentes spécifiques et à votre quête d’excellence corporelle.<br /><br />Ce temps privilégié de renforcement musculaire et articulaire s’appuie sur des exercices dynamiques issus de la danse classique, dont la précision et l’élégance contribuent à parfaire votre posture, à affiner votre souplesse, à dynamiser la circulation sanguine et à dissiper les tensions ancrées dans le corps.<br /><br />Une parenthèse brève mais régénératrice d’une intensité revitalisante précieuse au cœur du tumulte quotidien.<br /><br />Pour accéder à ces séances d’accompagnement exclusives et sur-mesure avec accessoires et/ou machines Merrithew® (MAT CLASSIQUE / REFORMER<sup>TM</sup> / CADILLAC<sup>TM</sup> / STABILITY BARRE<sup>TM</sup> / STABILITY CHAIR<sup>TM</sup> / ARC BARRELS<sup>TM</sup> / CARDIO TRAMP<sup>TM</sup>), veuillez me contacter via le formulaire de contact.",
                    time : "60",
                    price : "90"
                },

            ],
            displayModal : false,
            itemSelected : null
        }
    },
    methods : {
        openModal(item) {
            this.itemSelected = item;
            this.displayModal = true;
        },
        closeModal() {
            this.itemSelected = null;
            this.displayModal = false;
        }
    }
}
</script>

<style scoped lang="scss">
@import "./../scss/variables.scss";
    .program-container {
        margin-top:40px;
        margin-bottom:40px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        width: 100%;
    }
</style>